import { useQuery } from "@tanstack/react-query";
import { getInvoicePaymentLink } from "controller/api";
import type { ApiErrorType } from "shared";
import { sentryLogger } from "utilz";

/**
 * Hook for the unauthenticated `/pay-now` landing route.
 *
 * Resolves the latest payment link for an invoice. Never retries — a failed
 * attempt surfaces the error screen, from where the payer retries explicitly.
 */
export const useGetInvoicePaymentLink = ({
  mspId,
  invoiceId,
}: {
  mspId: string;
  invoiceId: string;
}) => {
  return useQuery({
    queryKey: ["payNow", "paymentLink", mspId, invoiceId],
    queryFn: () => getInvoicePaymentLink({ mspId, invoiceId }),
    enabled: !!mspId && !!invoiceId,
    retry: false,
    cacheTime: 0,
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "billing",
        functionName: "getInvoicePaymentLink",
      });
    },
  });
};
